import React from "react";
import { FormattedMessage } from "react-intl";
import DAYS_OF_WEEK from "./daysOfWeek";

const EVENT_DURATION_OPTIONS = [15, 30, 45, 60].map((minutes) => ({
  label: <FormattedMessage id="UserSettings.InterviewScheduling.Settings.DurationOption" values={{ minutes }} />,
  value: minutes,
}));

const DEFAULT_START_TIME = "9:00 AM";
const DEFAULT_END_TIME = "5:00 PM";
const DEFAULT_DURATION_MINUTES = 45;
const EVENT_NAME_MAX_LENGTH = 255;

const INTERVIEW_EVENT_STATUS = {
  active: "ACTIVE",
  missing: "MISSING",
  inactive: "INACTIVE",
  unsupported: "UNSUPPORTED",
};

const INTERVIEW_EVENT_STATUS_MESSAGES = {
  [INTERVIEW_EVENT_STATUS.missing]: "UserSettings.InterviewScheduling.Settings.EventMissing",
  [INTERVIEW_EVENT_STATUS.inactive]: "UserSettings.InterviewScheduling.Settings.EventInactive",
  [INTERVIEW_EVENT_STATUS.unsupported]: "UserSettings.InterviewScheduling.Settings.EventUnsupported",
};

const DEFAULT_AVAILABILITY = DAYS_OF_WEEK.map((day) => {
  const weekDay = !["SATURDAY", "SUNDAY"].includes(day.id);

  return {
    weekday: day.id,
    working: weekDay,
    dayStartsAt: weekDay ? DEFAULT_START_TIME : null,
    dayEndsAt: weekDay ? DEFAULT_END_TIME : null,
  };
});

const minutesOfDay = (time) => {
  const match = /^(\d{1,2}):(\d{2}) (AM|PM)$/.exec(time ?? "");
  if (!match) return null;

  const [, hours, minutes, period] = match;
  return ((Number(hours) % 12) + (period === "PM" ? 12 : 0)) * 60 + Number(minutes);
};

const isValidInterviewAvailability = (availability = []) => {
  const workingDays = availability.filter(({ working }) => working);

  return (
    workingDays.length > 0 &&
    workingDays.every(({ dayStartsAt, dayEndsAt }) => {
      const start = minutesOfDay(dayStartsAt);
      const end = minutesOfDay(dayEndsAt);
      return start !== null && end !== null && start < end;
    })
  );
};

export {
  DEFAULT_AVAILABILITY,
  DEFAULT_DURATION_MINUTES,
  EVENT_NAME_MAX_LENGTH,
  INTERVIEW_EVENT_STATUS,
  INTERVIEW_EVENT_STATUS_MESSAGES,
  isValidInterviewAvailability,
};

export default EVENT_DURATION_OPTIONS;
